import React, { useEffect } from 'react';
import { useScroll } from '../hooks/scroll.hook';

function ScrollHandler() {
  const { scrolled, showScrollTop, scrollToTop } = useScroll();

  // Optional: add/remove class on body
  useEffect(() => {
    if (scrolled) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  }, [scrolled]);

  return (
    <>
      {/* Scroll Top Button */}
      {showScrollTop && (
        <button
          className="scroll-top d-flex align-items-center justify-content-center"
          onClick={scrollToTop}
        >
          <i className="bi bi-arrow-up-short" />
        </button>
      )}
    </>
  );
}

export default ScrollHandler;
